export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.904 1.306a1 1 0 011.567 1.225l-3.707 5.904 7.563 2.62a1.001 1.001 0 01.393 1.638l-9.625 10a1.001 1.001 0 01-1.567-1.225l3.706-5.905-7.561-2.618a1.001 1.001 0 01-.394-1.639l9.625-10zm-7.1 10.26l8.418 2.915 1.972-2.049-8.418-2.915-1.972 2.05z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};